import type { QueryClient } from '@tanstack/react-query';

export const LIVE_BACKSTOP_INTERVAL = 5 * 60_000;

export const liveRefetchType = (): 'active' | 'none' =>
  typeof document !== 'undefined' && document.visibilityState === 'hidden' ? 'none' : 'active';

export const refetchInvalidatedWhenVisible = (client: QueryClient): (() => void) => {
  const visible = () => {
    if (document.visibilityState !== 'visible') return;
    void client.refetchQueries(
      { type: 'active', predicate: (query) => query.state.isInvalidated },
      { cancelRefetch: false },
    );
  };
  document.addEventListener('visibilitychange', visible);
  return () => document.removeEventListener('visibilitychange', visible);
};
